export default __webpack_public_path__ + "static/media/lt.b3247e0f.svg";